import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'

@Component({
    selector: 'app-news-and-current-affair',
    templateUrl: './news-and-current-affair.component.html',
    styleUrls: ['./news-and-current-affair.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsAndCurrentAffairComponent implements OnInit {
  mainTitle = ' CHCC News & Media'

  constructor() {}

  ngOnInit(): void {}
}
